module.exports = __webpack_public_path__ + "static/media/AgencyStorePOCIconFilter.e536c959.svg";